export default __webpack_public_path__ + "static/media/47fbe9ac27df2b6753e46dd20e7d79a11600813981032.1fbefda2.webp";